<script>
import Selector from '../../../vue/Selector.vue';

export default {
    extends: Selector,

    props: {
        citiesJson: String,
    },

    data() {
        let cities = JSON.parse(this.citiesJson);

        return {
            selectedCity: null,
            selectPlaceholder: this.trans('common.select_city_shorter'),
            cities: cities,
        };
    },

    mounted() {
        window.landingSelectCity = this;
    },

    watch: {
        opened(opened) {
            if (opened) {
                window.landingSelectCountry.opened = false;
            }
        },
    },

    methods: {
        optionLabel: function (option) {
            return option.name;
        },

        select: function (city) {
            if (city.separator !== true) {
                this.app.page.loadingStart();

                document.location.href = this.$parent.buildLocationUrl(city);

                Selector.methods.select.call(this, city);
            } else {
                // Prevent dropdown closing if the user click on a separator
                this.dropDownToggle();
            }
        },

        filterOptions: function (countryId) {
            countryId =
                countryId ||
                (window.landingSelectCountry.selectedCountry &&
                    window.landingSelectCountry.selectedCountry.id);

            let options = [];
            let citiesGroups = {};

            this.cities.forEach((city) => {
                if (!countryId || city.country.id === countryId) {
                    let localeCode = city.locale.code;
                    citiesGroups[localeCode] = citiesGroups[localeCode] || [];
                    citiesGroups[localeCode].push(city);
                }
            });

            Object.entries(citiesGroups).forEach((data) => {
                options.push({
                    name: this.app.locale.trans(`common.courses_in.${data[0]}`),
                    separator: true,
                });

                data[1].sort((a, b) => {
                    return parseFloat(a.tier_rank) - parseFloat(b.tier_rank);
                });

                data[1].forEach((city) => {
                    options.push(city);
                });
            });

            this.options = options;
        },
    },
};
</script>
